import React from 'react';

import logoAvacon from 'assets/pics/tenantLogos/logo_avacon.png';
import logoBag from 'assets/pics/tenantLogos/logo_bag.png';
import logoEdis from 'assets/pics/tenantLogos/logo_edis.png';
import logoLvn from 'assets/pics/tenantLogos/logo_lvn.png';
import logoMtn from 'assets/pics/tenantLogos/logo_mtn.png';
import logoShng from 'assets/pics/tenantLogos/logo_shng.svg';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { TENANT_ID } from 'global/constants';

const LOGO_SOURCES = {
  [TENANT_ID.EDI]: logoEdis,
  [TENANT_ID.SHNG]: logoShng,
  [TENANT_ID.AVA]: logoAvacon,
  [TENANT_ID.BAG]: logoBag,
  [TENANT_ID.LVN]: logoLvn,
  [TENANT_ID.MTN]: logoMtn,
};

export const TenantSwitchSelectionButton = ({ onClick, tenant, active }) => {
  const classes = classNames('tenant-switch-modal__tenant-button', {
    'tenant-switch-modal__tenant-button-active': active,
  });

  return (
    <div className={classes} onClick={onClick} onKeyDown={onClick} role="button" tabIndex={0}>
      <img
        src={LOGO_SOURCES[tenant]}
        alt={`${tenant} logo`}
        className="tenant-switch-modal__tenant-button-image"
      />
    </div>
  );
};

TenantSwitchSelectionButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  tenant: PropTypes.oneOf([
    TENANT_ID.EDI,
    TENANT_ID.SHNG,
    TENANT_ID.AVA,
    TENANT_ID.BAG,
    TENANT_ID.LVN,
    TENANT_ID.MTN,
  ]).isRequired,
  active: PropTypes.bool,
};

TenantSwitchSelectionButton.defaultProps = {
  active: false,
};
